import { Link as RouterLink } from "react-router-dom";
// material
import {Box, Container, Grid, Typography} from "@mui/material";
// mantenedorAdmin
import RedirectButton from "../RedirectButton";
import CarouselCenterMode from "../carousel/CarouselCenterMode";
import CarouselSkeleton from "../skeletons/CarouselSkeleton";
import useGetFeaturedMachines from "../../../hooks/portal/useGetFeaturedMachines";

export default function   BuyRent() {
  const {featured, loading} = useGetFeaturedMachines()

  return (
    <Container sx={{ py: { xs: 5, md: 10 } }}>
      <Box
        sx={{
          mb: 2,
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography variant="h2">Máquinas</Typography>
        <RouterLink to="/maquinas" style={{ textDecoration: "none" }}>
          <RedirectButton text='Ver todas' />
        </RouterLink>
      </Box>

      {
        featured.length > 0 && !loading &&
        <Box sx={{ overflow: "hidden", position: "relative" }}>
          <CarouselCenterMode type='products' arr={featured} />
        </Box>
      }

      {
        loading &&
        <Grid container>
          {
            [...Array(6)].map((item, index) => (
              <Grid item xs={12} sm={4} md={2} key={index + 1}>
                <CarouselSkeleton />
              </Grid>
            ))
          }
        </Grid>
      }
    </Container>
  );
}
